import { API_V1 } from "../config/main-axios";

class Payment {
    getExcelExport(params) {
        return API_V1.get("/shop/admin/order/export-excel/", {
            params: params,
            headers: {
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
            },
            responseType: 'blob'
        })
    }

    getAllPayment(data) {
        return API_V1.get("/shop/admin/order/", {
            params: data
        })
    }
}

export default new Payment();